import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  PAYMENT_TERMS_INDEX_REQUESTED,
  PAYMENT_TERMS_INDEX_SUCCESS,
  PAYMENT_TERMS_INDEX_FAILURE,

  PAYMENT_TERM_CREATE_REQUESTED,
  PAYMENT_TERM_CREATE_SUCCESS,
  PAYMENT_TERM_CREATE_FAILURE,

  PAYMENT_TERM_UPDATE_REQUESTED,
  PAYMENT_TERM_UPDATE_SUCCESS,
  PAYMENT_TERM_UPDATE_FAILURE,

  PAYMENT_TERM_DELETE_REQUESTED,
  PAYMENT_TERM_DELETE_SUCCESS,
  PAYMENT_TERM_DELETE_FAILURE,
} from '../types';

export const paymentTermsIndexRequested = () => {
  return {
    type: PAYMENT_TERMS_INDEX_REQUESTED
  }
};

export const paymentTermsIndexSuccess = (paymentTerms) => {
  return {
    type: PAYMENT_TERMS_INDEX_SUCCESS,
    payload: paymentTerms
  }
};

export const paymentTermsIndexFailure = () => {
  return {
    type: PAYMENT_TERMS_INDEX_FAILURE
  }
};

export const paymentTermCreateRequested = () => {
  return {
    type: PAYMENT_TERM_CREATE_REQUESTED
  }
};

export const paymentTermCreateSuccess = (paymentTerm) => {
  return {
    type: PAYMENT_TERM_CREATE_SUCCESS,
    paymentTerm: paymentTerm
  }
};

export const paymentTermCreateFailure = () => {
  return {
    type: PAYMENT_TERM_CREATE_FAILURE
  }
};

export const paymentTermUpdateRequested = () => {
  return {
    type: PAYMENT_TERM_UPDATE_REQUESTED
  }
};

export const paymentTermUpdateSuccess = (paymentTerm) => {
  return {
    type: PAYMENT_TERM_UPDATE_SUCCESS,
    paymentTerm: paymentTerm
  }
};

export const paymentTermUpdateFailure = () => {
  return {
    type: PAYMENT_TERM_UPDATE_FAILURE
  }
};


export const paymentTermDeleteRequested = (paymentTermId) => {
  return {
    type: PAYMENT_TERM_DELETE_REQUESTED,
    paymentTermId: paymentTermId
  }
};

export const paymentTermDeleteSuccess = () => {
  return {
    type: PAYMENT_TERM_DELETE_SUCCESS
  }
};

export const paymentTermDeleteFailure = () => {
  return {
    type: PAYMENT_TERM_DELETE_FAILURE
  }
};


export const paymentTermsIndex = (signedPayload) => {
  return (dispatch) => {
    dispatch(paymentTermsIndexRequested());

    let endPoint = Config.baseUrl + Config.paymentTerms;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(paymentTermsIndexSuccess(response.data));
      })
      .catch((error) => {
        dispatch(paymentTermsIndexFailure());
      });
  }
}

export const paymentTermCreate = (signedPayload, paymentTerm) => {
  return (dispatch) => {
    dispatch(paymentTermCreateRequested());

    let endPoint = Config.baseUrl + Config.paymentTerm;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, { paymentTerm: paymentTerm }, { headers: headers })
      .then((response) => {
        dispatch(paymentTermCreateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(paymentTermCreateFailure());
      });

  }
}

export const paymentTermUpdate = (signedPayload, paymentTermId, paymentTerm) => {
  return (dispatch) => {
    dispatch(paymentTermUpdateRequested());

    let endPoint = Config.baseUrl + Config.paymentTerm;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.put(endPoint, { paymentTermId: paymentTermId, paymentTerm: paymentTerm }, { headers: headers })
      .then((response) => {
        dispatch(paymentTermUpdateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(paymentTermUpdateFailure());
      });

  }
}

export const paymentTermDisable = (signedPayload, paymentTermId) => {
  return (dispatch) => {
    dispatch(paymentTermDeleteRequested(paymentTermId));

    let endPoint = Config.baseUrl + Config.paymentTerm + paymentTermId;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(paymentTermDeleteSuccess(response.data));
      })
      .catch((error) => {
        dispatch(paymentTermDeleteFailure());
      });
  }
}
